import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { MaterialModule } from '../material.module';
import { FlexLayoutModule } from '@angular/flex-layout';
import { RouterModule } from '@angular/router';
import { FileUploadModule } from 'ng2-file-upload';
import { ReactiveFormsModule } from '@angular/forms';

import { PillarModule } from '../pillar/pillar.module';
import { reducers } from './store/reducers';
import { routes } from './routes.config';

import { ModuleConfiguration } from './datawarehouse.module.config';
import { CoreModule } from '../core/core.module';
import { DataWarehouseDashboardComponent } from './components/data-warehouse-dashboard/data-warehouse-dashboard.component';
import { DataWarehouseService } from '../core/services';
import { DataWarehouseServiceEffects } from './service/DataWarehouseService.effects';
import { DataWarehouseEntityListComponent } from './components/data-warehouse-entity-list/data-warehouse-entity-list.component';
import { DataWarehouseWorkspaceComponent } from './components/data-warehouse-workspace/data-warehouse-workspace.component';
import { DataWarehouseEntityLookupComponent } from './components/data-warehouse-entity-lookup/data-warehouse-entity-lookup.component';
import { DataWarehouseEntityLookupModalComponent } from './components/data-warehouse-entity-lookup/data-warehouse-entity-lookup-modal.component';
import { DataWarehouseContextManagerService } from './service/data-warehouse-context-manager.service';
import { AddAssociationModalComponent } from './components/add-association-modal/add-association-modal.component';

@NgModule({
  entryComponents: [DataWarehouseEntityLookupModalComponent, AddAssociationModalComponent],
  declarations: [
    DataWarehouseDashboardComponent,
    DataWarehouseEntityListComponent,
    DataWarehouseWorkspaceComponent,
    DataWarehouseEntityLookupComponent,
    DataWarehouseEntityLookupModalComponent,
    AddAssociationModalComponent,
  ],
  imports: [
    CommonModule,
    MaterialModule,
    FlexLayoutModule,
    StoreModule.forFeature(ModuleConfiguration.moduleName, reducers),
    EffectsModule.forFeature([DataWarehouseServiceEffects]),
    RouterModule.forChild(routes),
    ReactiveFormsModule,
    PillarModule,
    FileUploadModule,
    CoreModule,
  ],
  exports: [DataWarehouseWorkspaceComponent, DataWarehouseEntityLookupComponent],
  providers: [DataWarehouseService, DataWarehouseContextManagerService],
})
export class DataWarehouseModule {}



// WEBPACK FOOTER //
// ./src/app/datawarehouse/datawarehouse.module.ts